import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.onboarding');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-onboarding',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.onboarding/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageOnboardingComponent implements OnInit {
    public step: number = 1;
    public totalSteps: number = 3;
    public isLoading: boolean = false;

    // Step 1: 신체 정보
    public age: string = '';
    public gender: string = '';
    public height: string = '';
    public weight: string = '';

    // Step 2: 건강 상태
    public conditions: string[] = [];
    public conditionOptions: any[] = [
        { id: 'diabetes', label: '당뇨' },
        { id: 'hypertension', label: '고혈압' },
        { id: 'hyperlipidemia', label: '고지혈증' },
        { id: 'heart', label: '심장질환' },
        { id: 'arthritis', label: '관절염' },
        { id: 'none', label: '해당없음' }
    ];

    // Step 3: 체질 선택
    public constitution: string = '';
    public constitutionOptions: any[] = [
        { id: 'taeyang', label: '태양인', desc: '활동적이고 상체가 발달' },
        { id: 'taeeum', label: '태음인', desc: '체격이 크고 소화력이 강함' },
        { id: 'soyang', label: '소양인', desc: '민첩하고 열이 많은 편' },
        { id: 'soeum', label: '소음인', desc: '체구가 작고 소화가 약한 편' },
        { id: 'unknown', label: '잘 모르겠어요', desc: 'AI가 분석해드립니다' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async nextStep() {
        if (this.step < this.totalSteps) {
            this.step++;
            await this.service.render();
        } else {
            await this.submit();
        }
    }

    public async prevStep() {
        if (this.step > 1) {
            this.step--;
            await this.service.render();
        }
    }

    public toggleCondition(id: string) {
        if (id === 'none') {
            this.conditions = ['none'];
        } else {
            this.conditions = this.conditions.filter(c => c !== 'none');
            const idx = this.conditions.indexOf(id);
            if (idx > -1) {
                this.conditions.splice(idx, 1);
            } else {
                this.conditions.push(id);
            }
        }
    }

    public selectConstitution(id: string) {
        this.constitution = id;
    }

    public async submit() {
        this.isLoading = true;
        await this.service.render();

        let res = await wiz.call("update_profile", {
            age: this.age,
            gender: this.gender,
            height: this.height,
            weight: this.weight,
            conditions: JSON.stringify(this.conditions),
            constitution: this.constitution
        });

        this.isLoading = false;
        if (res.code === 200) {
            this.service.href('/home');
        }
        await this.service.render();
    }
}

export default PageOnboardingComponent;